<template>
  <div class="index"> 
    <div class="index-container" style="background-color: #e8ebef;">
      <div>
        <div style="background: #fffbe8; width: 100%;padding: 6px 0;">
          <div style="width: 59%; margin: 0 auto; font-size: 50px;">
            <van-notice-bar left-icon="info-o">仅向该地址转入BSC/BEP20相关资产</van-notice-bar>
          </div>
        </div>
        <div v-if="idnex==1">
          <div style="width: 80%; margin: 80px auto 40px;">
            <van-cell-group inset>
              <van-field v-model="number"  type="number"  placeholder="请输充值金额" />
            </van-cell-group>
          </div>
          <div style="width: 75%; margin: 80px auto 40px; overflow: hidden;"> 
            <van-dropdown-menu>
              <van-dropdown-item  @change="dropdown" v-model="value1" :options="option1" />
            </van-dropdown-menu>
          </div>
          <!-- <van-count-down ref="countDown" millisecond :time="countdownTime" style="font-size: 25px; text-align: center;" format="HH:mm:ss:SS"/> -->
          <div v-if="isLoading" @click="handleRecharge" style="background: #07c160; color: #fff; width: 75%; border-radius: 20px; text-align: center; padding: 10px 0; margin: 100px auto;  cursor: pointer; ">确认充值</div>
          <div v-if="!isLoading" style="background: #07c160; color: #fff; width: 75%; border-radius: 20px; text-align: center; padding: 10px 0; margin: 100px auto;">
            <van-loading size="24px"  color="#fff" >支付加载中...</van-loading>
          </div>
        </div>
        <div v-show="idnex==2"> 
            <div v-if="hasUnconfirmedPay==1" style="text-align: center; margin: 20px auto;color: #ed6a0c; ">BSC/BEP20区块待确认...</div>
          <div v-show="qrText">
              <canvas ref="qrcanvas" width="300" height="300" style="display: block; margin: 20px auto 30px;"></canvas>
              <div style="text-align: center; margin: 20px auto;">请支付 <span style="color: #ed6a0c;">{{number}}</span> {{value1==1 ?'USDT':'BDC'}}/当前已支付 <span style="color: #42b883;">{{actualPaidAmount}}</span> {{value1==1 ?'USDT':'BDC'}}</div>
              <div @click="copyTextToClipboard" style="text-align: center; cursor: pointer; color: #42b883;">{{qrText}} <van-icon   name="coupon-o" /></div>
              <div style="text-align: center; margin: 10px auto;">付款倒计时</div>
              <van-count-down ref="countDown" @finish="onCountdownFinish" millisecond :time="countdownTime" style="font-size: 18px; text-align: center; color: #ee0a24;" format="HH:mm:ss:SS"/>
          </div>
          <div v-show="!qrText">
            <van-loading size="50px" color="#07c160" style="margin-top: 40px" vertical>支付加载中...</van-loading>
          </div>
        </div>
        <div v-if="idnex==3">
          <div style="display: block; text-align: center; margin: 40px auto 30px;">
          <van-icon  size="50" color="#42b883" name="wechat-pay" />
          <div style="color: #42b883;">支付成功</div>
          </div>
          <div style="text-align: center; margin: 40px auto;color: #42b883; ">请支付 {{number}} {{value1==1 ?'USDT':'BDC'}}/当前已支付 {{actualPaidAmount}} {{value1==1 ?'USDT':'BDC'}}</div>
          <div style="text-align: center; margin: 40px auto;">
            <van-button style="width: 200px; border-radius: 6px; margin-right: 15px;" @click="idnex=1">返回充值</van-button>
            <van-button style="width: 200px;  border-radius: 6px; margin-left: 15px;"  @click="$router.back()">返回上一页</van-button>
          </div>
        </div>
        <div v-if="idnex==4">
          <div style="display: block; text-align: center; margin: 40px auto 30px;">
          <van-icon  size="50" color="#ee0a24" name="wechat-pay" />
          <div style="color: #ee0a24;">支付失败</div>
          </div>
          <div style="text-align: center; margin: 40px auto;color: #ee0a24; ">请支付 {{number}} {{value1==1 ?'USDT':'BDC'}}/当前已支付 {{actualPaidAmount}} {{value1==1 ?'USDT':'BDC'}}</div>

          <div style="text-align: center; color: #ee0a24; ">支付金额自动退款</div>
          <div style="text-align: center; margin: 40px auto;">
            <van-button style="width: 200px; border-radius: 6px; margin-right: 15px;" @click="idnex=1">返回充值</van-button>
            <van-button style="width: 200px;  border-radius: 6px; margin-left: 15px;"  @click="$router.back()">返回上一页</van-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import QRCode from 'qrcode'
export default {
  components: {
    
  },
  data() {
    return {
       option1: [
          { text: 'USDT', value: 1 },
          { text: 'BDC', value: 2 },
        ],
         value1: 1,
         number: '',
         uId:0,
         countdownTime:900000,
         idnex:1,
         isLoading: true,
         orderSn:'',
         qrText: '',
         timerId:null,
         actualPaidAmount:0,
         hasUnconfirmedPay:0,
    }
  },
  created(){
    this.uId = this.$route.query.id;
  },
  methods: {
    dropdown(index){
      console.log(index)
    },
    handleRecharge(){

      let that = this;
      if(that.number < 0.999 || that.number == ''){
        that.$toast.fail('Minimum recharge amount: 1');
        return;
      }

      if(that.uId== undefined || that.uId== null){
        that.$toast.fail('Unable to retrieve User ID');
        return;
      }
      let timestamp = Date.now();
        // app_id: that.value1 == 1 ? 2 : 1,
      let params = {
        order_sn: 'SN-'+ timestamp +'-'+ that.uId,
        chain:"BSC",
        token: that.value1 == 1 ? 'USDT':'BDC',
        amount: that.number,
      }
      
      that.isLoading = false; 
      that.actualPaidAmount = 0.0000;     
      axios.post('https://proxy-web3pay.ibuilt.com.au/web3pay_proxy/create_payorder', params,{
      }).then(res => {
        if(res.data.code == 1){
          that.orderSn =  res.data.data.orderSn;
          that.qrText = res.data.data.walletAddress;
          that.idnex = 2;
          that.generateQRCode()
          that.$refs.countDown.reset(900000);
          clearInterval(that.timerId);
          that.timerId = setInterval(()=>{
            that.payorderInfo()
          },3000)

        }else{
          that.isLoading = true;
          that.$toast.fail(res.data.msg);
          clearInterval(that.timerId);
        }
      })
    },
    generateQRCode() {
      QRCode.toCanvas(this.$refs.qrcanvas, this.qrText, {
        width: 300,
        colorDark: '#000000',
        colorLight: '#ffffff',
        margin: 1
      }, (error) => {
        if (error) console.error(error)
      })
    },
    // 封装方法
    copyTextToClipboard() {
      let that = this;
      try {
        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(this.qrText)
        } else {
          this.fallbackCopyText(this.qrText)
        }
        that.$toast.success('复制成功')
      } catch (err) {
        console.log(err)
        that.$toast.success('复制失败')
      }
    },
    fallbackCopyText(text) {
      let that = this;
      const textArea = document.createElement('textarea')
      textArea.value = text
      textArea.style.position = 'fixed'
      textArea.style.left = '-999999px'
      textArea.style.top = '-999999px'
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()
      
      try {
        document.execCommand('copy')
        that.$toast.success('复制成功')
      } catch (err) {
        that.$toast.success('复制失败')
      }
      document.body.removeChild(textArea)
    },

    payorderInfo(){
      let that = this;
      try{ 
        axios.get(`https://proxy-web3pay.ibuilt.com.au/web3pay_proxy/query_payorder?order_sn=${that.orderSn}`,{
        })
        .then(response => {
          if(response.data.code==1){
            that.actualPaidAmount = response.data.data.actualPaidAmount;
            that.hasUnconfirmedPay = response.data.data.hasUnconfirmedPay;
            if(Number(response.data.data.payAmount) <= Number(response.data.data.actualPaidAmount)){
              that.$toast.success('充值成功')
              that.$refs.countDown.reset();
              that.$refs.countDown.pause();
              clearInterval(that.timerId);
              setTimeout(()=>{
                that.idnex = 3;
                that.hasUnconfirmedPay = 0;
                that.isLoading = true;
              },1000)
            }
          }
        });
      }catch(err){
        console.log(err)
      }
    },
    onCountdownFinish(){
      let that = this;
      clearInterval(that.timerId);
      that.idnex = 4;
      that.$refs.countDown.reset();
      that.$refs.countDown.pause();
      that.isLoading = true;
    }
  
  },

}
</script>

<style>
  .notice-swipe {
    height: 40px;
    line-height: 40px;
    color: #333;
  }
  .index {
      width: 100%;
      height: 80vh;
      display: flex;
      justify-content: center;
      align-items: center;
  }
  
  .index-container {
      width: 600px;
      height: 600px;
      background: #ffffff;
      border-radius: 12px;
      justify-content: center;
      align-items: center;
      color: #333;
      /* 三层阴影效果 */
      box-shadow: 
          0 2px 4px rgba(0, 0, 0, 0.05),
          0 8px 16px rgba(0, 0, 0, 0.08),
          0 16px 32px rgba(0, 0, 0, 0.12);
      border-radius: 8px;
  }
  .van-notice-bar__content{
    font-size: 17px;
  }
  .van-notice-bar__left-icon{
    font-size: 22px !important;
    margin-right: 5px;
  }
  .van-dropdown-menu__bar{
    width: 100%;
    margin: 0 auto;
    border-radius: 8px;
  }
  .van-dropdown-item--down{
    width: 450px !important;
    margin: 10px auto;
    height:auto !important;
  }
  .van-overlay{
    background: none !important;
  }
</style>